'use client';

/**
 * Confirm-style goal screen — v1 has exactly one route (CLF-C02), so this is
 * a single confirmation, not a menu of certs to choose from.
 */
export default function GoalPick({
  route,
  onConfirm,
}: {
  route: string;
  onConfirm: () => void;
}) {
  return (
    <section className="onboarding-panel">
      <span className="onboarding-badge">{route}</span>
      <h1 className="onboarding-title">{route}: Cloud Practitioner</h1>
      <p className="onboarding-text">
        Daily training sessions built on spaced repetition, until you&apos;re
        ready for the exam.
      </p>
      <button
        type="button"
        className="onboarding-btn onboarding-btn-primary"
        onClick={onConfirm}
      >
        Start training
      </button>
    </section>
  );
}
